import { FormValidator } from '@pocketrn/client/dist/app-utils';
import localePrimer from './localePrimer';

const formValidator = new FormValidator(localePrimer);

export default formValidator;
